import TransferWithinAStation from '@mui/icons-material/TransferWithinAStation';
import { FixMe } from '@greenkub-fronts/shared/interface';

export function ChangeUserIcon(props: FixMe) {
  return <TransferWithinAStation {...props} />;
}

export default ChangeUserIcon;
